<script setup>
// NOTICE: KAPTION-INTEGRATION — security-center.UI.3: switch row (canvas: Main › Usuarios y roles)
import { useI18n } from 'vue-i18n';
import Switch from 'dashboard/components-next/switch/Switch.vue';

defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  soon: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});
const model = defineModel({ type: Boolean, default: false });
const { t } = useI18n();
</script>

<template>
  <div class="flex items-center gap-4 px-4 py-3.5">
    <div class="flex flex-col flex-1 min-w-0 gap-1">
      <span
        class="flex flex-wrap items-center gap-2 text-sm font-semibold text-n-slate-12"
      >
        {{ title }}
        <span
          v-if="soon"
          class="px-1.5 py-0.5 text-xs font-normal rounded-full bg-n-alpha-2 text-n-slate-11"
        >
          {{ t('KAPTION_SECURITY.COMMON.SOON') }}
        </span>
      </span>
      <span v-if="description" class="text-sm text-n-slate-11">{{
        description
      }}</span>
    </div>
    <Switch v-model="model" :disabled="disabled || soon" :aria-label="title" />
  </div>
</template>
